import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TranslationEntity } from '../../domain/entities/TranslationEntity'
import type { TextTranslationAdminDto } from '@/backend/market'
export class TranslationModel extends TranslationEntity {
  constructor(dataDto: TextTranslationAdminDto) {
    super()
    mapEntityProperties<TranslationEntity>(this, dataDto)
  }
}
